export default {
  cockpitManagerApi: {
    cockpitConfig: {
      getCockpitThemeActive: '/api/cockpitConfig/getCockpitThemeActive',
      changeCockpitTheme: '/api/cockpitConfig/changeCockpitTheme',
      getCockpitMenus: '/api/cockpitConfig/getCockpitMenus',
      getList: '/api/cockpitConfig/getList',
      loadDetail: '/api/cockpitConfig/loadDetail',
      loadDetailByCode: '/api/cockpitConfig/loadDetailByCode',
      saveConfig: '/api/cockpitConfig/saveConfig',
      updateConfig: '/api/cockpitConfig/updateConfig',
      delConfigs: '/api/cockpitConfig/delConfigs',
      changeStatus: '/api/cockpitConfig/changeStatus'
    },
    cockpitCommon: {
      getVedios: 'api/cockpitCommon/',
      getAlarm: 'api/cockpitCommon/getAlarm'
    },
    overview: {
      parkInfo: 'api/overview/parkInfo'
    }
  }
}